// extracted by mini-css-extract-plugin
module.exports = {"restaurant_favourites":"RestaurantHome_restaurant_favourites__3_KnY"};